import { render, staticRenderFns } from "./Evento.vue?vue&type=template&id=96a16a1c"
import script from "./Evento.vue?vue&type=script&lang=js"
export * from "./Evento.vue?vue&type=script&lang=js"
import style0 from "./Evento.vue?vue&type=style&index=0&id=96a16a1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports